import React from "react";
import { Input } from "@chakra-ui/react";
import "./taxmax.css";

const TaxMax = ({ formValues, setFormValues }) => {
  return (
    <div className="taxmax-holder">
      {/* <div className="linethrough-holder">
        <div className="linethrough">BUY TAX MAX 6</div>
        <div className="linethrough">SELL TAX MAX 6</div>
      </div> */}
      <div className="input-taxmax">
        <label htmlFor="tokenname">Marketing Wallet <span className="astrick">*</span></label>
        <Input
          placeholder="0x..."
          size="sm"
          onChange={(e) => {
            setFormValues({ ...formValues, marketingWallet: e.target.value });
          }}
        />
      </div>
    </div>
  );
};

export default TaxMax;
